import React from 'react';
import { withThousandsSeparator } from 'utils/numberFormat';
import { RarityPointsValue } from './characterDetailsPage.styled';

export const RarityPoints = ({ points, isFull }) => (
  <RarityPointsValue>
    +{withThousandsSeparator(Math.round(points))} {isFull && 'rarity points'}
  </RarityPointsValue>
);
